import { useParams, Navigate } from "react-router-dom";
import { ContentPage } from "../components/ContentPage";
import { RESOURCE_PAGES } from "../data/resourcePages";

export default function ArticlePage() {
  const { slug } = useParams();
  const data = RESOURCE_PAGES[slug];
  if (!data) return <Navigate to="/resources" replace />;
  return <ContentPage data={data} path={`/resources/${slug}`} eyebrow={data.group} />;
}
